
import Pie2D from './pie2d';
import Pie3DDataset from '../_internal/datasets/pie3d';
import { pluckNumber } from '../_internal/lib/lib';
let math = Math,
  mathRound = math.round,
  mathMin = math.min,
  mathMax = math.max,
  mathPI = math.PI;

class Pie3D extends Pie2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Pie3D';
  }

  constructor () {
    super();
    // this.fireGroupEvent = true;
    this.defaultPlotShadow = 0;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Pie3D';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.is3D = true;
    config.friendlyName = '3D Pie Chart';
    config.defaultDatasetType = 'Pie3D';
    config.plotborderthickness = 0.1;
    config.alphaanimation = 0;
  }

  // Pie2D (base) has defaultPlotShadow, but 3d does not.
  animate () {
    var i,
      point,
      graphic,
      pointGraphics,
      pointConfig,
      element,
      args,
      up,
      start,
      end,
      chart = this,
      chartComponents = chart.components,
      dataSet = chartComponents.dataset[0],
      dataSetConfig = dataSet.config,
      dataSetComponents = dataSet.components,
      plotItems = dataSetComponents.data,
      len = plotItems.length,
      alphaAnim = dataSetConfig.alphaAnimation,
      animationObj = chart.get('config', 'animationObj'),
      animationDuration = animationObj.duration || 0,
      mainElm = animationObj.dummyObj,
      animObj = animationObj.animObj,
      animType = animationObj.animType;

    if (!alphaAnim) {
      for (i = 0; i < len; i++) {
        point = plotItems[i];
        pointGraphics = point.graphics;
        pointConfig = point.config;
        args = pointConfig.shapeArgs;
        up = 2 * mathPI;
        element = pointGraphics.element;

        // start values
        if (element) {
          element.attr({
            sAngle: up,
            eAngle: up
          });

          start = args.sAngle;
          end = args.eAngle;

          /* Raphael animation do not support start and end attributes.
                      * Since the attribute setting for Pie3D goes through attrFN
                      * method of Pie3DManager, we can safely use some unused
                      * attributes for pie3D to pass through Raphael animation module
                      * and trap the attributes to convert to start and end in attrFN */
          graphic.animateWith(mainElm, animObj, {
            cx: start - up,
            cy: end - up
          }, animationDuration, animType);
        }
      }
    }
  }
  // manages the spaces when no radius is given.
  _stubRadius (chartWorkingWidth, labelMaxW, chartWorkingHeight, labelDistance, slicingDistance,
    lineHeight, pieMinRadius) {
    var chart = this,
      dataSet = chart.getChildren('dataset')[0],
      conf = dataSet.config,
      fcJSONChart = dataSet.config,
      userGivenSlicingDist = pluckNumber(fcJSONChart.slicingdistance),
      dataLabelOptions = conf.dataLabelOptions ||
                  (conf.dataLabelOptions = dataSet._parseDataLabelOptions()),
      availableRadius = 0,
      // Slicing distance can not be less then the MINSLICINGDIST (10)
      MINSLICINGDIST = 10,
      pieYScale = conf.pieYScale,
      pieSliceDepth = conf.pieSliceDepth,
      shortFall;
    chartWorkingHeight -= pieSliceDepth;
    availableRadius = mathMin((chartWorkingWidth / 2) - labelMaxW - slicingDistance,
      ((chartWorkingHeight / 2) - lineHeight) / pieYScale) - labelDistance;

    if (availableRadius >= pieMinRadius) { // there has space for min width
      pieMinRadius = availableRadius;
    } else if (!userGivenSlicingDist) { /** @todo smartyfy Labels */
      // If slicing distance is not given by the user, adjust slicing distance based on pie radius.
      shortFall = pieMinRadius - availableRadius;
      // Now reduce the pie slicing distance, but restrict the minimum slicing distance to 10 pixels.
      slicingDistance = labelDistance = mathMax(mathMin(labelDistance - shortFall,
        slicingDistance), MINSLICINGDIST);
    }
    conf.slicingDistance = slicingDistance;
    conf.pieMinRadius = pieMinRadius;
    dataLabelOptions.distance = labelDistance;

    return pieMinRadius;
  }
  _startingAngle (angle, relative) {
    var ang,
      chart = this,
      dataSet = chart.getChildren('dataset')[0],
      seriesData = dataSet.config,
      // Angle is differently handled in Pie2D and Pie3D. So, angles is converted
      // accordingly to the same base. Its radian in 2D while in degrees in 3D.
      // Moreover, sense of positive angle is opposite in the two.
      currentAngle = (ang = seriesData.startAngle) + (ang < 0 ? 360 : 0);

    if (!isNaN(angle)) {
      if (!(seriesData.singletonCase || seriesData.isRotating)) {
        angle += relative ? currentAngle : 0;
        dataSet._rotate(angle);
        currentAngle = angle;
      }
    }
    // Angle normalised in the range of [0, 360]
    return mathRound(((currentAngle %= 360) + (currentAngle < 0 ? 360 : 0)) * 100) / 100;
  }
  getDSdef () {
    return Pie3DDataset;
  }
}

export default Pie3D;
